import { render, staticRenderFns } from "./discountDelete.vue?vue&type=template&id=4fdb4484"
import script from "./discountDelete.vue?vue&type=script&lang=js"
export * from "./discountDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports